import { createAuth } from '@spotify-internal/oauth-silent-authentication';
import { IS_CLIENT_ENV } from '@helpers/constants';

export const CLIENT_ID = '91770b1012b049d8baa8fa2c2c8bf2a1';

let silentAuth: any;
if (IS_CLIENT_ENV) {
  silentAuth = createAuth({
    clientId: CLIENT_ID,
    // this was the default scope in creator-auth-proxy when we switched token providers
    // https://ghe.spotify.net/creator/creator-auth-proxy/blob/f0412cb90bcd067e4bea736383d20b89e0df5680/src/main/java/com/spotify/creator/authproxy/handlers/WebAuthHandler.java#L47-L52
    scopes: [
      'streaming',
      'user-read-email',
      'user-read-private',
      'ugc-image-upload',
      'openid',
      'profile',
    ],
  });
}

export default silentAuth;
